import React from 'react';

import { Route, Routes } from 'react-router-dom';

import LegalEntityForm from './LegalEntityForm';
import LegalEntityList from './LegalEntityList';

const LegalEntities: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<LegalEntityList />} />
      <Route path="/create" element={<LegalEntityForm />} />
      <Route path="/:legalEntityId" element={<LegalEntityForm />} />
    </Routes>
  );
};
export default LegalEntities;
